import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { Column } from '../components/column';
import { WrapperItem } from '../components/wrapper-item';
import { Spacer } from '../components/spacer';
import { Section } from '../components/section';
import { Text } from '../components/text';
import { Group } from '../components/group/group';
import { Button } from '../components/button';
import { LinkWrapper } from '../components/link-wrapper';
import { shorthand } from '../utils/css-utils';
import { mobileFullWidthColumnClassName, mobileNoWrapColumnClassName, } from '../utils/defaults';
import { BdiWrapper } from '../components/bdi-wrapper';
import { GenericImage } from './generic-image';
import { mixLeftColumn, mixRightColumn, mixButton, mixText, mixImageWrapper, mixSpacer, mixColumn, mixColumnNoWrap, mixSectionNoWrap, mixImageWrapperFullWidth, } from './mix-css-classes';
export var SectionMix = function (props) {
    var _a;
    var section = props.section, cssClass = props.cssClass, isRtl = props.isRtl, override = props.override, overrideProps = props.overrideProps, experiments = props.experiments;
    var leftColumnPadding = section.leftColumnPadding, // Left column right padding
    rightColumnPadding = section.rightColumnPadding, // Right column left padding
    outerPadding = section.outerPadding, innerPadding = section.innerPadding;
    var sectionCssClass = cssClass + " " + cssClass + "-mix-all-css-paddings";
    var leftColumnPaddings = '', middleColumnPaddings = '', rightColumnPaddings = '';
    if (innerPadding) {
        leftColumnPaddings = innerPadding.top + "px " + leftColumnPadding + " " + innerPadding.bottom + "px " + innerPadding.left + "px";
        middleColumnPaddings = innerPadding.top + "px " + leftColumnPadding + " " + innerPadding.bottom + "px " + rightColumnPadding;
        rightColumnPaddings = innerPadding.top + "px " + innerPadding.right + "px " + innerPadding.bottom + "px " + rightColumnPadding;
    }
    var direction = isRtl ? 'rtl' : 'ltr';
    var firstColumnPadding = direction === 'ltr' ? leftColumnPaddings : rightColumnPaddings;
    var secondColumnPadding = direction === 'ltr' ? rightColumnPaddings : leftColumnPaddings;
    var columnPropsList = section.columnsWidths.map(function (column, idx, all) {
        var columnProps = {
            verticalAlign: 'top',
            padding: middleColumnPaddings,
            cssClass: mixColumn,
            width: column.displayWidth,
        };
        if (idx === 0) {
            columnProps.padding = firstColumnPadding;
            columnProps.cssClass = mixLeftColumn;
        }
        if (idx === all.length - 1) {
            columnProps.padding = secondColumnPadding;
            columnProps.cssClass = mixRightColumn;
        }
        if (section.noWrap) {
            columnProps.cssClass = columnProps.cssClass + " " + mixColumnNoWrap + " " + mixColumnNoWrap + "-" + (column.width || 50) + " " + mobileNoWrapColumnClassName;
        }
        if (!section.noWrap) {
            columnProps.cssClass = columnProps.cssClass + " " + mobileFullWidthColumnClassName;
        }
        return columnProps;
    });
    var columns = columnPropsList.map(function (columnProps, idx) {
        return (React.createElement(Column, __assign({ key: idx }, columnProps, { forceWidth: !!section.noWrap }),
            React.createElement(RenderColumns, { section: section, isRtl: isRtl, idx: idx, override: override, overrideProps: overrideProps, experiments: experiments })));
    });
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: classnames(sectionCssClass, (_a = {},
                _a[mixSectionNoWrap] = section.noWrap,
                _a)), padding: shorthand(outerPadding), direction: direction }, section.noWrap ? (React.createElement(Group, { direction: direction }, columns)) : (columns))));
};
function RenderColumns(_a) {
    var section = _a.section, isRtl = _a.isRtl, idx = _a.idx, override = _a.override, overrideProps = _a.overrideProps, experiments = _a.experiments;
    var regions = section.regions.reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr.regionId] = curr, _a)));
    }, {});
    var spacerHeight = section.spacerHeight;
    var row = section.layout.rows[0];
    var result = [];
    row.columns[idx].regionIds.forEach(function (id, index) {
        if (index > 0) {
            result.push(React.createElement(Spacer, { cssClass: mixSpacer, key: "spacer-" + index, height: spacerHeight }));
        }
        // There are some cases when mix region in it's layout have an id that
        // doesn't exist in data.regions. So, the region that doesn't exist won't
        // be rendered and email-service won't throw an exception.
        if (!regions[id]) {
            return;
        }
        if (regions[id].type === 'image') {
            result.push(React.createElement(RenderImage, { key: regions[id].regionId, region: regions[id], noWrap: section.noWrap, override: override, overrideProps: overrideProps }));
        }
        else if (regions[id].type === 'button') {
            result.push(React.createElement(RenderButton, { key: regions[id].regionId, region: regions[id], override: override, overrideProps: overrideProps }));
        }
        else if (regions[id].type === 'text') {
            result.push(React.createElement(RenderText, { key: regions[id].regionId, region: regions[id], isRtl: isRtl, override: override, overrideProps: overrideProps, experiments: experiments }));
        }
    });
    return React.createElement(React.Fragment, null, result);
}
function RenderImage(_a) {
    var _b;
    var region = _a.region, noWrap = _a.noWrap, override = _a.override, overrideProps = _a.overrideProps;
    var style = {
        width: '100%',
    };
    var classes = classnames(mixImageWrapper, (_b = {},
        _b[mixImageWrapperFullWidth] = !noWrap,
        _b));
    return (React.createElement(GenericImage, { cssClass: classes, href: region.link, key: "image", src: region.src, width: region.width, height: region.height, style: style, imgStyle: region.imgStyle, alt: "", override: override, overrideProps: overrideProps && overrideProps(region), showAfterLoad: true }));
}
function RenderButton(_a) {
    var _b, _c, _d;
    var region = _a.region, override = _a.override, overrideProps = _a.overrideProps;
    var button = region.button, minWidth = region.minWidth, maxWidth = region.maxWidth;
    return (React.createElement(Button, { key: "button", align: button.align, backgroundColor: button.backgroundColor, border: button.border, borderRadius: typeof button.borderRadius === 'number'
            ? button.borderRadius + "px"
            : button.borderRadius, color: button.color, cssClass: mixButton + " html-emails-button", fontFamily: cleanFont(button.fontFamily), fontSize: button.fontSize, fontWeight: (_b = button.fontWeight) === null || _b === void 0 ? void 0 : _b.toString(), fontStyle: button.fontStyle !== 'normal' ? button.fontStyle : undefined, href: button.href, innerPadding: (_c = button.innerPadding) === null || _c === void 0 ? void 0 : _c.trim(), padding: "0px", textDecoration: button.textDecoration, rel: "noopener", minWidth: minWidth, maxWidth: maxWidth, override: override, overrideProps: overrideProps && overrideProps(region) },
        React.createElement(LinkWrapper, { fontWeight: "inherit", isRtl: button.isRtl },
            React.createElement(BdiWrapper, { text: ((_d = button.text) === null || _d === void 0 ? void 0 : _d.trim()) ? button.text : '\u00A0' }))));
}
function RenderText(_a) {
    var region = _a.region, isRtl = _a.isRtl, override = _a.override, overrideProps = _a.overrideProps, experiments = _a.experiments;
    // TODO: here should be also addded fontSize and fontStyle. They previously
    // existed but their values were incorrect.
    var baseTextProps = {
        align: region.align,
        color: region.color,
        cssClass: mixText,
        fontFamily: region.fontFamily,
        paddingBottom: '0px',
        paddingTop: '0px',
        textTransform: region.textTransform,
    };
    var defaultProps = { padding: '0px' };
    var textContainerProps = isRtl ? { dir: 'rtl', style: {} } : { style: {} };
    var combinedTextProps = __assign({}, __assign(__assign({}, defaultProps), baseTextProps));
    combinedTextProps.align = undefined;
    textContainerProps.style = { textAlign: baseTextProps.align };
    return (React.createElement(Text, __assign({ key: "text" }, combinedTextProps, { override: override, overrideProps: overrideProps && overrideProps(region) }),
        React.createElement(SecureHtml, { html: region.html, containerProps: textContainerProps, skipCleaning: experiments['specs.so.public.Sanitize'] !== 'true' })));
}
function cleanFont(s) {
    if (s === void 0) { s = ''; }
    return s.toLowerCase().trim().replace(/"/g, '').replace(/'/g, '');
}
//# sourceMappingURL=section-mix.js.map